import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  min-height: 430px;
  padding: 18px 22px 22px;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeaderMain = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Title = styled.h3`
  margin: 0;
  color: ${(props) => props.theme.colors.darkerblue};
  font-size: 14px;
  font-weight: 800;
`;

export const Meta = styled.p`
  margin: 4px 0 0;
  color: ${(props) => props.theme.colors.label};
  font-size: 11px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
`;

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

export const Timestamp = styled.span`
  color: ${(props) => props.theme.colors.label};
  font-size: 11px;
  font-weight: 600;
  text-align: right;
  font-variant-numeric: tabular-nums;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// Segmented control (linear / log).
export const Segmented = styled.div`
  display: inline-flex;
  border: 1px solid ${(props) => props.theme.colors.disabled};
  border-radius: 8px;
  overflow: hidden;
`;

export const SegButton = styled.button`
  appearance: none;
  border: 0;
  cursor: pointer;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 700;
  font-family: inherit;
  letter-spacing: 0.02em;
  background: ${(props) =>
    props.$active ? props.theme.colors.blue : 'transparent'};
  color: ${(props) =>
    props.$active ? props.theme.colors.white : props.theme.colors.label};
  transition: background 0.15s, color 0.15s;

  & + & {
    border-left: 1px solid ${(props) => props.theme.colors.disabled};
  }
`;

export const ToggleButton = styled.button`
  appearance: none;
  cursor: pointer;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 700;
  font-family: inherit;
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      props.$active ? props.theme.colors.blue : props.theme.colors.disabled};
  background: ${(props) =>
    props.$active ? props.theme.colors.blue : 'transparent'};
  color: ${(props) =>
    props.$active ? props.theme.colors.white : props.theme.colors.label};
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s;
`;

export const CanvasWrap = styled.div`
  position: relative;
  width: 100%;
  height: 320px;
  margin-top: 8px;

  canvas {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  pointer-events: none;
  transform: translate(-50%, -115%);
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 7px 10px;
  border: 1px solid ${(props) => props.theme.colors.disabled};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.card};
  color: ${(props) => props.theme.colors.label};
  font-size: 11px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.28);
  z-index: 3;

  strong {
    color: ${(props) => props.theme.colors.darkerblue};
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }
`;

export const StateBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 250px;
  padding: 0 24px;
  color: ${(props) =>
    props.$error ? props.theme.colors.red : props.theme.colors.label};
  font-size: 13px;
  font-style: ${(props) => (props.$error ? 'normal' : 'italic')};
`;

// Small legend under the chart: floor vs peak color key.
export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 2px;
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.label};
`;

export const Swatch = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: ${(props) => props.color};
`;
